<template>
  <v-app id="inspire" :class="{ lightBg: lightTheme, darkBg: !lightTheme }">
    <v-main class="grey lighten-2">
      <router-view v-if="ready === true"></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { authComputed } from './shared/helpers.js'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name: 'App',
  async created() {
    if (this.$route.name !== 'sorn' && this.$route.name !== 'login') {
      await this.refreshLogin()
      await this.refreshUser()
    }
    await this.toggleReady()
  },
  methods: {
    ...mapActions(['getApps', 'getUser', 'refreshLogin']),
    ...mapMutations(['refreshUser', 'toggleReady']),
  },
  computed: {
    ...authComputed,
    ...mapState(['lightTheme', 'user', 'ready']),
  },
  watch: {
    user: {
      async handler(newVal) {
        let component = this
        setInterval(function() {
          component.refreshLogin()
        }, component.user.token_expires * 1000 * 60 - 30000)
        await this.getApps()
        await this.getUser(this.user.id)
      },
      deep: true,
    },
  },
}
</script>
<style>
.sidebar-btn {
  font-size: 12px !important;
}
.lightBg {
  background: url('../public/light-honeycomb.png') repeat !important;
}

.darkBg {
  background: url('../public/dark-honeycomb.png') repeat !important;
}

.white {
  color: #ffffff;
}

.darkGray {
  color: #222222;
}

/* overwrite vuetify styles */
.theme--light.v-subheader {
  color: rgba(0, 0, 0, 0.85) !important;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  border: none;
  -webkit-text-fill-color: #333333;
  -webkit-box-shadow: none;
  transition: background-color 1000s ease-in-out0s;
}
</style>
